import { rootApi } from '@components/rootApi';
import { tryZodParse } from '@utils/api';

import { clientsResponseSchema } from './schemas';
import type { ClientsResponse } from './schemas';

const pathWithBaseUrl = (path: string) => `/api/v3/${path}`;

const clientsApi = rootApi.injectEndpoints({
  endpoints: builder => ({
    getClients: builder.query<ClientsResponse, void>({
      query: () => ({ url: pathWithBaseUrl('clients') }),
      transformResponse: response =>
        tryZodParse(clientsResponseSchema, response),
    }),
  }),
});

export const { useGetClientsQuery } = clientsApi;
